import React, { useState } from 'react';
import { Button, Paper, TextField, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const fieldSx = {
    backgroundColor: '#f9f9f9',
    '& .MuiInputLabel-root': { color: '#666666' },
    '& .MuiOutlinedInput-root': {
        color: '#111111',
        '& fieldset': { borderColor: '#cccccc' },
        '&:hover fieldset': { borderColor: '#999999' },
    },
};

function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setMessage('');
        setError('');
        try {
            const response = await api.post('users/reset-password', {
                email: email.trim().toLowerCase(),
            });
            setMessage(
                response.data?.message ||
                'Se o email estiver cadastrado, você receberá as instruções para redefinir sua senha em breve. A entrega pode levar alguns minutos — confira também a pasta de spam, caso não apareça na caixa de entrada.'
            );
        } catch (err) {
            const serverMessage = err.response?.data?.error || err.response?.data?.message;
            setError(
                serverMessage ||
                'Erro ao tentar enviar as instruções. Por favor, tente novamente.'
            );
            console.error('Erro na recuperação de senha:', err);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                backgroundImage: 'url(/images/3D_banner_1.webp)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    zIndex: 1,
                }}
            />
            <Paper
                elevation={3}
                sx={{
                    zIndex: 2,
                    padding: 4,
                    width: '90%',
                    maxWidth: 500,
                    backgroundColor: '#ffffff',
                    color: '#000000',
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                }}
            >
                <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold' }}>
                    <Box
                        component="img"
                        src="/images/logo-acompanha-transp.png"
                        alt="Acompanha Logo"
                        sx={{ width: '180px', height: 'auto', display: 'inline-block' }}
                    />
                </Typography>
                <Typography
                    variant="h6"
                    align="center"
                    gutterBottom
                    sx={{ color: '#222222', fontWeight: 600, mb: 2 }}
                >
                    Esqueci Minha Senha
                </Typography>
                <form onSubmit={handlePasswordReset}>
                    <TextField
                        label="Email"
                        type="email"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        sx={fieldSx}
                    />
                    {message && (
                        <Typography color="success.main" variant="body2" gutterBottom sx={{ mt: 1 }}>
                            {message}
                        </Typography>
                    )}
                    {error && (
                        <Typography color="error" variant="body2" gutterBottom sx={{ mt: 1 }}>
                            {error}
                        </Typography>
                    )}
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        disabled={isSubmitting}
                        sx={{
                            marginTop: 2,
                            background: isSubmitting
                                ? 'linear-gradient(to right, #6c757d, #495057)'
                                : 'linear-gradient(to right, #007bff, #0056b3)',
                            color: '#fff',
                            fontWeight: 'bold',
                            borderRadius: '8px',
                            padding: '10px 0',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                            '&:hover': {
                                background: isSubmitting
                                    ? 'linear-gradient(to right, #6c757d, #495057)'
                                    : 'linear-gradient(to right, #0056b3, #003d7a)',
                            },
                        }}
                    >
                        {isSubmitting ? 'Enviando...' : 'Enviar Instruções'}
                    </Button>
                    <Button
                        onClick={() => navigate('/admin/login')}
                        fullWidth
                        sx={{
                            marginTop: 2,
                            color: '#007bff',
                            fontWeight: 600,
                            textDecoration: 'underline',
                            '&:hover': {
                                color: '#0056b3',
                                backgroundColor: 'transparent',
                                textDecoration: 'underline',
                            },
                        }}
                    >
                        Voltar ao Login
                    </Button>
                </form>
            </Paper>
        </Box>
    );
}

export default ForgotPasswordPage;
